/**
 * Where the banner previews on the Season 4 screen come from.
 *
 * These point at the *original* artwork served by the public site, not at
 * downscaled copies committed here. Copies drifted out of date every time the
 * artwork was re-exported, so the dashboard ended up showing a banner that no
 * longer matched what visitors saw. Reading the live files means the preview
 * cannot go stale — the trade-off is that this screen needs the public site to
 * be reachable, and the images are full-size (~1.5MB each), so they are loaded
 * lazily.
 *
 * Paths must stay in step with `src/utils/season-4-banner.ts` and the two hero
 * sections in the client app.
 */

/** Public site root, no trailing slash. */
export const SITE_URL = (
  process.env.REACT_APP_SITE_URL || "https://mulimgcc.org"
).replace(/\/+$/, "");

const url = (path) => `${SITE_URL}${path}`;

/**
 * Each option lists one or more locale pairs.
 *
 * "default" is the only one with more than one: it does not select a single
 * image, it means "leave every page on the banner it already ships with", and
 * the home page and the award page ship different ones. Showing just one of
 * them is what made the old preview misleading.
 */
export const BANNER_SOURCES = {
  default: [
    {
      // See DEFAULT_BANNER in home-screen-hero-seaction.tsx. The capital B in
      // the English filename is not a typo — it is the name on disk.
      pageKey: "home",
      ar: url("/images/banner__ar.png"),
      en: url("/images/Banner__en.png"),
    },
    {
      // See DEFAULT_BANNER in smart-investor-award-hero-seaction.tsx.
      pageKey: "award",
      ar: url("/images/closing_moment_ar.png"),
      en: url("/images/closing_moment_en.png"),
    },
  ],
  banner_1: [
    {
      ar: url("/images/banners_2026/1/1_ar.png"),
      en: url("/images/banners_2026/1/1_en.png"),
    },
  ],
  banner_2: [
    {
      ar: url("/images/banners_2026/2/2_ar.png"),
      en: url("/images/banners_2026/2/2_en.png"),
    },
  ],
  banner_3: [
    {
      ar: url("/images/banners_2026/3/3_ar.png"),
      en: url("/images/banners_2026/3/3_en.png"),
    },
  ],
  banner_4: [
    {
      ar: url("/images/banners_2026/4/4_ar.png"),
      en: url("/images/banners_2026/4/4_en.png"),
    },
  ],
};
